import L from 'leaflet';
import { isEmpty } from 'lodash';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet.pm.css';


// Extend the Polyline edit to allow disabling the edit mode and resetting to the initial state
const {
    disable: _disableSuper,
    enable: _enableSuper,
    _initMarkers: initMarkers,
} = L.PM.Edit.Line.prototype;


L.PM.Edit.Line.include({
    enable(...args) {
        _enableSuper.call(this, ...args);
        if (typeof this._initialCoords === 'undefined') {
            this._initialCoords = this._layer.getLatLngs();
        }
    },
    disable(reset = false) {
        _disableSuper.call(this);

        if (reset && typeof this._initialCoords !== 'undefined') {
            this._layer.setLatLngs(this._initialCoords);
        }

        delete this._initialCoords;
    },
    _initMarkers() {
        initMarkers.call(this);
        if (this._layer.feature && this._layer.feature.geometry.type === 'LineString') {
            const layers = Object.values(this._markerGroup._layers)
                .filter((l) => !!(l._middleMarkerPrev || l._middleMarkerNext));
            layers[0].remove();
            layers[layers.length - 1].remove();
        }
    },
});

L.Map.include({
    flyToBoundsCenter(bounds, _center, zoom = false) {
        let center = _center;

        if (isEmpty(bounds)) {
            if (zoom) {
                this.flyToZoom(center);
            } else {
                this.panTo(center);
            }
            return;
        }

        if (isEmpty(center)) {
            center = L.latLngBounds(bounds).getCenter();
        }

        let maxDistance = -1;
        bounds.forEach((coordinates) => {
            const distance = this.distance(L.latLng(center), L.latLng(coordinates));
            if (distance > maxDistance) {
                maxDistance = distance;
            }
        });

        // Center the map on the center but with such a zoom so that all bounds are shown
        // Get the furthest bounds point from the center and the distance between them
        // Make a circle with such a radius and focus the map on it
        const circle = L.circle(center, { radius: maxDistance });
        circle.addTo(this);
        const circleCoordinates = circle.getBounds();
        circle.removeFrom(this);
        if (zoom) {
            this.flyToBounds(circleCoordinates);
        } else {
            this.panInsideBounds(circleCoordinates);
        }
    },
});

L.Map.include({
    flyToZoom(point) {
        const mapZoom = this.getZoom();
        if (mapZoom > 20) {
            this.flyTo(point, 20);
        } else if (mapZoom < 18) {
            this.flyTo(point, 18);
        } else {
            this.flyTo(point);
        }
    },
});
